<header class="site_header">
  <div class="headerTop_bar">
    <div class="conta_iner">
      <nav>
        <a (click)="routing()">
          <figure class="site_logo">
            <img [src]="assetsConst.Logo" alt="Mega Store" />
          </figure>
        </a>
        <div class="topBar_search" *ngIf="!isCmsPage">
          <megastore-search
            [search]="search"
            (searchOutput)="fetchSearchOutput($event)"
            (focusSearch)="onFocus($event)"
            [placeholderText]="'lookingSearch' | translate"></megastore-search>
          <div
            class="search_drop"
            [ngClass]="{
              active: searchDropDown
            }">
            <ng-container
              *ngIf="
                searchedData &&
                (searchedData.product.length ||
                  searchedData.category.length ||
                  searchedData.brand.length)
              ">
              <ul>
                <li
                  *ngFor="let brand of searchedData.brand"
                  (click)="routeToProductList(brand, GlobalSearchType.BRAND)">
                  {{ brand.name | language: [brand, selectedLanguage, "name"] }}
                </li>
                <li
                  *ngFor="let category of searchedData.category"
                  (click)="
                    routeToProductList(category, GlobalSearchType.CATEGORY)
                  ">
                  {{
                    category.name
                      | language: [category, selectedLanguage, "name"]
                  }}
                </li>
                <li
                  *ngFor="let product of searchedData.product"
                  (click)="
                    routeToProductList(product, GlobalSearchType.PRODUCT)
                  ">
                  {{
                    product.productName
                      | language: [product, selectedLanguage, "productName"]
                  }}
                </li>
              </ul>
            </ng-container>
            <ng-container
              *ngIf="
                !isRecentAllowed &&
                searchedData &&
                !(
                  searchedData.product.length ||
                  searchedData.category.length ||
                  searchedData.brand.length
                )
              ">
              <megastore-nodatafound type="noProducts"></megastore-nodatafound>
            </ng-container>
            <ng-container
              *ngIf="
                isRecentAllowed &&
                recentSearchedData &&
                (recentSearchedData.product.length ||
                  recentSearchedData.category.length ||
                  recentSearchedData.brand.length)
              ">
              <div class="d_flex">
                <h3>{{ "RecentlysearchProducts" | translate }}</h3>
                <button
                  (click)="clearRecentSearch()"
                  type="button"
                  class="clear">
                  {{ "clear" | translate }}
                </button>
              </div>
              <ul>
                <li
                  *ngFor="let brand of recentSearchedData.brand"
                  (click)="routeToProductList(brand, GlobalSearchType.BRAND)">
                  {{ brand.name | language: [brand, selectedLanguage, "name"] }}
                </li>
                <li
                  *ngFor="let category of recentSearchedData.category"
                  (click)="
                    routeToProductList(category, GlobalSearchType.CATEGORY)
                  ">
                  {{
                    category.name
                      | language: [category, selectedLanguage, "name"]
                  }}
                </li>
                <li
                  *ngFor="let product of recentSearchedData.product"
                  (click)="
                    routeToProductList(product, GlobalSearchType.PRODUCT)
                  ">
                  {{
                    product.productName
                      | language: [product, selectedLanguage, "productName"]
                  }}
                </li>
              </ul>
            </ng-container>
            <ng-container
              *ngIf="
                isRecentAllowed &&
                recentSearchedData &&
                !(
                  recentSearchedData.product.length ||
                  recentSearchedData.category.length ||
                  recentSearchedData.brand.length
                )
              ">
              <megastore-nodatafound type="search"></megastore-nodatafound>
            </ng-container>
          </div>
        </div>
        <ul class="site_menu">
          <li>
            <a class="language_drop form_group">
              <mat-form-field>
                <mat-select
                  [(value)]="selectedLanguage"
                  (selectionChange)="selectedLang($event)"
                  panelClass="language-dropdown-panel"
                  class="language-select">
                  <mat-option value="en">
                    {{ "English" | translate }}
                    <span>.</span>
                  </mat-option>
                  <mat-option value="ar">
                    {{ "العربية" | translate }}
                    <span>.</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </a>
          </li>
          <ng-container *ngIf="!isCmsPage">
            <li *ngIf="currentAddress && !isCheckoutPage" class="location_drop_wrp">
              <a class="location_drop">
                <img [src]="assetsConst.locationIcon" alt="Icon" />
                <p (click)="openAddressModal($event)">
                  <b>
                    {{ "deliverTo" | translate }}
                  </b>
                  <small
                    [matTooltip]="
                      currentAddress !== 'null'
                        ? currentAddress
                        : profileDetails?.address ?? ''
                    ">
                    {{
                      currentAddress !== "null"
                        ? currentAddress
                        : profileDetails?.address
                    }}
                  </small>
                </p>
              </a>
            </li>
            <li class="usr_ac">
              <a mat-icon-button [matMenuTriggerFor]="menu">
                <ng-container *ngIf="isSignedIn; else staticImage">
                  <span>
                    {{
                      fetchUserName(profileDetails ? profileDetails.name : "")
                        | uppercase
                    }}
                  </span>
                </ng-container>
                <ng-template #staticImage>
                  <img [src]="assetsConst.userIcon" alt="Icon" />
                </ng-template>
                {{ "account" | translate }}
              </a>
              <mat-menu #menu="matMenu" class="account_drop">
                <!-- <h2>{{ "welcome" | translate }}</h2> -->

                <button
                  type="button"
                  *ngIf="!isSignedIn"
                  (click)="LoginModal()"
                  class="btnn btn_secondary br">
                  <span>{{ "loginSignUp" | translate }}</span>
                </button>
                <ng-container *ngIf="isSignedIn">
                  <!-- AFTER USER LOGIN -->
                  <!-- <figure class="user_info" routerLink="/view-profile/v2">
                    <img
                      [src]="
                        profileDetails?.image
                          ? profileDetails?.image
                          : assetsConst.userIcon
                      "
                      alt="Image" />
                    <figcaption>
                      <p>{{ profileDetails?.name }}</p>
                      <p>
                        <small>{{ "viewProfile" | translate }}</small>
                      </p>
                    </figcaption>
                  </figure>
                  <hr /> -->
                  <ng-container *ngFor="let item of myDetailsDropDown">
                    <button
                      type="button"
                      *ngIf="
                        !(
                          (item.title === 'logout' ||
                            item.title === 'deleteAccount') &&
                          !isSignedIn
                        ) ||
                        (item.title !== 'logout' && isSignedIn)
                      "
                      mat-menu-item
                      (click)="action(item)"
                      [ngClass]="{
                        logout_text:
                          item.title === 'logout' ||
                          item.title === 'deleteAccount'
                      }">
                      <span>{{ item.title | translate }}</span>
                    </button>
                  </ng-container>
                </ng-container>
              </mat-menu>
            </li>
            <li class="mob_none">
              <a (click)="routeToPath('/my-wishlist/v2')">
                <img [src]="assetsConst.heartIcon" alt="Icon" />
                {{ "wishlist" | translate }}
              </a>
              <p class="bag_cnt like_cnt" *ngIf="wishListCount && isSignedIn">
                {{ wishListCount }}
              </p>
            </li>
            <li class="mob">
              <a (click)="routeToPath('/notifications')">
                <img [src]="assetsConst.notiIcon" alt="Icon" />
              </a>
              <p class="bag_cnt" *ngIf="bagListCount && isSignedIn">
                {{ bagListCount }}
              </p>
            </li>
            <li>
              <a (click)="routeToPath('/cart')">
                <img [src]="assetsConst.bagIcon" alt="Icon" />
                {{ "bag" | translate }}
              </a>
              <p class="bag_cnt" *ngIf="bagListCount && isSignedIn">
                {{ bagListCount }}
              </p>
            </li>
          </ng-container>
        </ul>
      </nav>
    </div>
  </div>
  <!-- <div
    (mouseleave)="falseDropDown()"
    class="menu_bar"
    [ngClass]="{ active_Mobile: active_Mobile }"
    *ngIf="!isCmsPage">
    <div class="conta_iner">
      <ul class="megaMenu">
        <li *ngFor="let category of homeData?.totalCategories; let i = index">
          <div class="category_box">
            <figure>
              <img [src]="category.image" />
            </figure>
          </div>
         
          <a
            (mouseover)="triggerDropDown(category)"
            (click)="openDropDown(category)">
            {{ category.name | language: [category, selectedLanguage, 'name'] }}
          </a> -->

  <!-- <div
            class="megaMenu_drop"
            [ngClass]="{
              active: showDropDown
            }"
            [ngClass]="{
              show_vis: selectedCategory === category
            }">
            <div class="gap_m">
              <div *ngIf="selectedCategory" class="megaMenu_list">
                <h2>
                  {{
                    selectedCategory.name
                      | language: [selectedCategory, selectedLanguage, 'name']
                  }}
                </h2>
                <ul class="gap_p">
                  <li *ngFor="let subCategory of selectedCategory.subCategory">
                    <a
                      (click)="
                        reloadCurrentRoute(selectedCategory, subCategory)
                      ">
                      {{
                        subCategory.name
                          | language: [subCategory, selectedLanguage, 'name']
                      }}
                    </a>
                  </li>
                </ul>
              </div>
              <figure *ngIf="selectedCategory">
                <img [src]="selectedCategory.image" />
                <figcaption>
                  {{
                    selectedCategory.name
                      | language: [selectedCategory, selectedLanguage, 'name']
                  }}
                </figcaption>
              </figure>
            </div>
          </div> -->
  <!-- </li>
      </ul>
    </div> -->
  <!-- </div> -->
</header>
